import d from "./ghl-ui.es1372.js";
function i(e) {
  var t = this.__data__, a = d(t, e);
  return a < 0 ? void 0 : t[a][1];
}
export {
  i as default
};
